export function baseAuthURL () {
  return process.env.VUE_APP_API_URL;
}

export function baseURLVertical () {
  return process.env.VUE_APP_URL_VERTICAL;
}

export function baseURLCookie () {
  return process.env.VUE_APP_COOKIE_DOMAIN;
}

export function baseURLSuite () {
  return process.env.VUE_APP_SUITE_URL;
}

export function isDebugMode () {
  return process.env.NODE_ENV !== 'production';
}

export function isLoggedIn (state) {
  if (state.user.aud == null) return false;
  return true;
}

export function isAuthIn (state) {
  if (state.authStatus !== 'success') return false;
  return true;
}

export function userMail (state) {
  if (state.user.email === undefined) return '';
  return state.user.email;
}

export function fullName (state) {
  if (state.user.given_name === undefined) return '';
  return state.user.given_name + ' ' + state.user.family_name;
}

export function isAdmin (state) {
  if (state.publicMode) return false;
  let result = false;

  if (state.user.role) result = state.user.role.includes('Admin');

  return result;
}
export function isCiudadano (state) {
  if (state.publicMode) return true;
  let result = false;

  if (state.user.role) result = state.user.role.includes('Ciudadano');

  return result;
}
export function isOnlyAccess (state) {
  if (state.publicMode) return false;
  let result = false;

  if (state.user.role) {
    result = state.user.role.includes('Ciudadano') || state.user.role.includes('Admin') || state.user.role.includes('Gestor');
  }

  return !result;
}
export function haveAccess (state) {
  if (state.publicMode) return true;
  if (!state.user || !state.user.role) return false;
  return state.user.role.includes('Access');
}

export function isExternal (state) {
  if (state.publicMode) return false;
  return state.user.isExternal;
}

export function userId (state) {
  return state.user.nameid;
}

export function userData (state) {
  return state.user;
}

export function ciudadData (state) {
  return state.CiudadSelected;
}
export function imgObjetivoEstrategico (state) {
  return state.imgObjetivoEstrategico;
}
export function objetivoEspecifico (state) {
  return state.objetivoEspecifico;
}
export function nameIndicador (state) {
  return state.nameIndicador;
}
export function loopIndicators (state) {
  return state.loopIndicators;
}

export function idMunicipio (state) {
  return state.idMunicipio;
}

export function isPublicMode (state) {
  return state.publicMode;
}
